import React, { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { motion } from 'framer-motion';
export function OnlineCounter() {
  const [count, setCount] = useState(42);
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => {
        const change = Math.floor(Math.random() * 5) - 2; // -2 to +2
        const newCount = prev + change;
        return newCount < 10 ? 10 : newCount > 150 ? 150 : newCount;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="fixed top-32 left-4 z-40 flex items-center gap-2 bg-white/90 backdrop-blur-md border border-slate-200 rounded-full px-3 py-1.5 shadow-md" data-id="element-115">
      <div className="relative flex h-2 w-2" data-id="element-116">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-117"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-118"></span>
      </div>
      <Users className="w-3.5 h-3.5 text-slate-500" data-id="element-119" />
      <span className="text-xs font-medium text-slate-600" data-id="element-120">
        <span className="text-[#0a2540] font-bold" data-id="element-121">{count}</span> personas en
        línea
      </span>
    </motion.div>;
}